import { LoadingIcon } from 'components/Icons';
import React, { useEffect, useState } from 'react'

export default function ImageWithFallback({ src, fallbackSrc, fallbackExtensions = [], ...restProps }) {
    if(!fallbackSrc){
        console.error('ImageWithFallback: no fallback src provided. If not needed, use <img> tag instead.');
    }

    const [validSrc, setValidSrc] = useState();
    const [otherExtensions] = useState(fallbackExtensions);

    useEffect(() => {
        let newSrc = src;
        if(!src){
            newSrc = fallbackSrc;
        }
        const extensionIndex = newSrc.lastIndexOf('.');
        const defaultExtention = newSrc.substr(extensionIndex + 1);
        const possibleExtensions = [defaultExtention, ...otherExtensions];
        let i = 0;
        const image = new Image();
        image.onload = () => setValidSrc(newSrc);
        image.onerror = (e) => {
            i++;
            if(i >= possibleExtensions.length){
                setValidSrc(fallbackSrc);
            } else {
                newSrc = image.src = `${src.substr(0, extensionIndex)}.${possibleExtensions[i]}`;
            }
        }
        image.src = newSrc;
    }, [src, fallbackSrc, otherExtensions])

    return (
        !validSrc
        ?
        <LoadingIcon />
        :
        <img src={validSrc} alt="" {...restProps} />
    )
}
